import { render, staticRenderFns } from "./border-input.vue?vue&type=template&id=b54fe262&scoped=true"
import script from "./border-input.vue?vue&type=script&lang=js"
export * from "./border-input.vue?vue&type=script&lang=js"
import style0 from "./border-input.vue?vue&type=style&index=0&id=b54fe262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54fe262",
  null
  
)

export default component.exports